"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CarouselArrowContainer = exports.AssetImg = exports.AssetContainer = void 0;
const styled_breakpoints_1 = require("styled-breakpoints");
const styled_components_1 = __importStar(require("styled-components"));
exports.AssetContainer = styled_components_1.default.div `
	display: flex !important;
	justify-content: center;
	align-items: center;
	width: 100vw !important;
	height: 100vh;
`;
exports.AssetImg = styled_components_1.default.img `
	max-width: 95%;
	max-height: 95%;
	object-fit: contain;
`;
exports.CarouselArrowContainer = styled_components_1.default.div `
	position: absolute;
	top: 50%;
	display: flex;
	justify-content: center;
	align-items: center;
	width: 3rem;
	height: 3rem;
	background-color: ${props => props.theme.color.gray2};
	border-radius: 100%;
	z-index: 1001;
	pointer-events: auto;
	font-size: 1.5rem;
	cursor: pointer;
	transform: translateY(-50%);
	${props => props.position === 'left'
    ? (0, styled_components_1.css) `
					left: 1rem;
			  `
    : (0, styled_components_1.css) `
					right: 1rem;
			  `}
	${(0, styled_breakpoints_1.down)('sm')} {
		font-size: 1rem;
		width: 2rem;
		height: 2rem;
	}
`;
